























































































































import Basic from '@/components/widgets/Basic.vue';

import { default as Component } from 'vue-class-component';
import SessionState from '@/interfaces/SessionState';

import IocContainer from '@/container/IocContainer';
import SERVICES from '@/container/Services';

import Format from '@/interfaces/Format';
import Api from '@/interfaces/Api';

const formatProvider = IocContainer.get<Format>(SERVICES.FORMAT);
const ApiProvider = IocContainer.get<Api>(SERVICES.API);

@Component({
  filters: {
    iban: formatProvider.iban(),
    date: formatProvider.date(),
    zip: formatProvider.zip()
  }
})
export default class HsgShowCompletedData extends Basic {
  public paymentDetails: {
    bank: string;
    bic: string;
  } = {
    bank: '',
    bic: ''
  };
  public providers: any[] = [];

  get salutationDisplay(): string {
    return this.getSalutationForKey(String(this.dataReview.salutation));
  }
  get billingSalutationDisplay(): string {
    return this.getSalutationForKey(String(this.dataReview.billingSalutation));
  }

  get dataReview(): SessionState {
    return this.store.getters.getSession;
  }

  get bic(): string {
    return this.paymentDetails.bic;
  }

  get bank(): string {
    return this.paymentDetails.bank;
  }

  get startOfDelivery(): string | null {
    switch (this.dataReview.customerSpecification) {
      case 'desired_date':
        return this.dataReview.desiredDate ?? '';
      case 'terminated_in_person':
        return this.dataReview.terminationDate ?? '';
      case 'relocation_at':
        return this.dataReview.relocationDate ?? '';
    }
    return '';
  }

  get provider(): { id: any; text: string } {
    const provider = this.providers.filter((p) => {
      return p.codeNumber === this.dataReview.previousProviderCodeNumber;
    })[0];
    return provider
      ? provider
      : {
          id: null,
          text: ''
        };
  }

  public mounted(): void {
    ApiProvider.getProviders().then((response) => {
      this.providers = response.data;
    });
    if (this.dataReview && typeof this.dataReview.iban !== 'undefined') {
      ApiProvider.getBicAndBank(String(this.dataReview.iban)).then((responseIban) => {
        this.paymentDetails.bank = responseIban.data.bank;
        this.paymentDetails.bic = responseIban.data.bic;
      });
    }
  }

  protected getSalutationForKey(key: string): string {
    switch (Number(key)) {
      case 1:
        return this.$t('contract.widget.salutation.mr').toLocaleString();
      case 2:
        return this.$t('contract.widget.salutation.mrs').toLocaleString();
      case 3:
        return this.$t('contract.widget.salutation.family').toLocaleString();
      case 8:
        return this.$t('contract.widget.salutation.company').toLocaleString();
      case 9:
      default:
        return '';
    }
  }
}
